import React from "react";
import Typography from "@material-ui/core/Typography";

export default function Title(){
    return (
        <Typography variant="h6" color="inherit">
            CVR Flyttemønster
        </Typography>
    );
}